__webpack_require__.p = "https://www.hdb.gov.sg/_next/";